import ensureTimezone from '@webapp-next/lib/utils/ensure-timezone';

export default function getLocationTZ(id) {
  const TIMEZONE =
    window?.$dt?.objConfig?.MySetup?.WorkplaceConfig[id]?.TIMEZONE;

  if (!TIMEZONE) {
    return ensureTimezone(
      Intl.DateTimeFormat().resolvedOptions().timeZone // eslint-disable-line new-cap
    );
  }

  return ensureTimezone(TIMEZONE);
}
